import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { defaultPageSize } from '@synergy/config';

import { INQUIRIES_RECEIVE, INQUIRIES_REQUEST } from './inquiry-actions';
import { InquiryListItem } from '../models/inquiry-list-item';

export interface InquiryReducerState {
    inquiries: PaginatedResponse<InquiryListItem>;
    requesting: boolean;
}

const initialInquiryReducerState: InquiryReducerState = {
    inquiries: { items: [], total: 0, page: 1, limit: defaultPageSize },
    requesting: false,
};

export const inquiryReducer = (
    state: InquiryReducerState = initialInquiryReducerState,
    action: AnyAction
): InquiryReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case INQUIRIES_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case INQUIRIES_RECEIVE: {
            return {
                ...state,
                inquiries: rest['inquiries'],
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
